import styled, { css } from "styled-components";
import { tableHeaderSize, creditHeaderSize } from "../BookingOverview.styled";
import { motion } from "framer-motion";

export const CreditInvoiceButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const CreditButton = styled.button`
  background: transparent;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;

  svg {
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
    color: #1e22ff;
    transition: transform 0.2s ease-in-out;
    &:hover {
      color: #7a89f4;
      transform: scale(1.2);
    }
    ${({ disabled }) =>
      !disabled &&
      css`
        &:hover {
          color: #7a89f4;
          transform: scale(1.2);
        }
      `}
  }
`;

export const BillingAddress = styled.p`
  ${creditHeaderSize}
  font-family: Rubik;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  margin: 10px 0;
  span {
    color: #1e1f43;
    display: block;
  }

  @media screen and (width > 2000px) {
    line-height: 20px;
  }
`;

export const MissingBillingAddress = styled.p`
  color: #7a89f4;
  margin: 16px 0;
`;

export const CreditInvoiceEmail = styled.p`
  ${creditHeaderSize}
  margin: 10px 0;
  font-family: Rubik;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #1e22ff;
`;

export const FieldForm = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 14px;
  align-items: flex-start;
  cursor: pointer;

  div {
    width: 100%;

    label {
      ${creditHeaderSize}
      color: #4056f4;
      font-weight: 400;
      line-height: 17px;
      font-family: "Rubik", sans-serif;
      font-style: normal;
      margin-bottom: 0;
      margin-right: 10px;
      cursor: ${({ clickable }) => (clickable ? "pointer" : "default")};

      &:hover {
        color: ${({ clickable }) => (clickable ? "#1e22ff" : "inherit")};
      }
    }
  }
`;

export const NumLocations = styled.span`
  color: #7a89f4;
  margin-left: 4px;
`;

export const CampaignTable = styled.ul`
  list-style-type: none;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
`;

export const TableItem = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  position: relative;
  padding: 6px 18px 6px 12px;

  &:first-child {
    padding-left: 0;
  }

  &:not(:first-child)::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 1px;
    height: 50px;
    border-left: 1px dotted #abb4f4;
  }
`;

export const TableItemTitle = styled.h3`
  ${tableHeaderSize}
  color: #4056f4;
  font-weight: 400;
  margin: 0;
`;

export const TableItemField = styled.div`
  ${creditHeaderSize}
  color: #1e1f43;
  font-weight: 500;
  line-height: 17px;
`;

export const TableJobTitle = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  gap: 4px;
  padding: 6px 18px 6px 0;
  margin-bottom: 1rem;

  ${TableItemField} {
    line-height: 1;
  }
`;

export const ChannelIcons = styled.div`
  display: inline-flex;
  flex-flow: row wrap;
  gap: 10px;
  svg {
    width: 20px;
    height: 20px;
  }
`;

export const CreativeImages = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;

  img,
  video {
    flex-shrink: 0;
    max-width: 75px;
    max-height: 75px;
    object-fit: cover;
    border-radius: 10px;
    cursor: pointer;
    transition: transform 0.2s ease-in-out;

    &:hover {
      transform: scale(1.2);
    }
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  margin-bottom: 12px;
`;

export const OptimiseContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 6px;
  margin-top: 20px;

  img {
    max-width: 75px;
    margin-right: 20px;
    border-radius: 15%;
  }
`;

export const OptimiseText = styled.div`
  h3 {
    ${creditHeaderSize};
    margin: 0 0 3px;
    color: #1e1f43;
    font-family: Rubik;
    font-style: normal;
    font-weight: 500;
    line-height: 17px;
  }
  p {
    ${creditHeaderSize};
    color: #4056f4;
    font-family: Rubik;
    font-style: normal;
    font-weight: 400;
    line-height: 17px;
    max-width: 230px;
    margin-right: 20px;
  }
`;

export const ReviewAmountContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 11px;
  margin-left: auto;

  > div {
    margin: 0 8px;
  }
`;

export const AddButton = styled(motion.button)`
  ${creditHeaderSize};
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  font-family: Rubik;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 8px 18px;
  color: #1e22ff;
  background-color: transparent;
  border: 1px solid #1e22ff;
  border-radius: 4px;
  cursor: pointer;

  &:active {
    transform: scale(1.05);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
